module.exports = __webpack_public_path__ + "static/RemoveHooks-fb14d526ebcf74e5479c11273015d1a6.png";